import { render, staticRenderFns } from "./SettingLayOut.vue?vue&type=template&id=fb534028&scoped=true&"
import script from "./SettingLayOut.vue?vue&type=script&lang=js&"
export * from "./SettingLayOut.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/setting.css?vue&type=style&index=0&id=fb534028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb534028",
  null
  
)

export default component.exports